// extracted by mini-css-extract-plugin
export default {"reportSwipeViewWrapper":"NtGylZ_fIwftRb4Jvgem","swipeContentItemNavigation":"qJxYmrJ1D8M4LtuqIm9p","swipeContentItemNavigation__right":"p3ESH37sHqH_rWbndp9s"};